import { QUOTATION_DOCUMENT_MAX_BYTES } from '@felix/domain';
import type { RfqDetail } from '@felix/ui';
import { ApiError, api } from './api.js';
import { tusUpload } from './tus-upload.js';

/**
 * Kayıtsız tedarikçinin teklif belgesi (04.11 notları D1; ADR 0168): dosya tus ile kendi amacıyla
 * yüklenir (sunucu sınırı 10 MB, tür içerikten), sonra ofisin girdiği teklife konur. Yeni belge
 * eskisini silmez. Açma adresi `Range` destekli ofis ucudur; her açılış kayda geçer.
 */
export const QUOTATION_DOCUMENT_UPLOAD_PURPOSE = 'quotation_document';

const id = encodeURIComponent;

export async function uploadQuotationDocument(
  rfqId: string,
  quotationId: string,
  file: File,
): Promise<RfqDetail> {
  // Sunucu da denetler; büyük ya da boş dosya hiç gönderilmez
  if (file.size <= 0 || file.size > QUOTATION_DOCUMENT_MAX_BYTES) {
    throw new ApiError('FILE_TOO_LARGE', 413);
  }
  const uploadId = await tusUpload(file, {
    purpose: QUOTATION_DOCUMENT_UPLOAD_PURPOSE,
    onProgress: () => undefined,
  });
  return api<RfqDetail>(`/office/rfqs/${id(rfqId)}/quotations/${id(quotationId)}/documents`, {
    method: 'POST',
    body: { uploadId, fileName: file.name },
  });
}

export const quotationDocumentUrl = (documentId: string) =>
  `/api/office/quotation-documents/${id(documentId)}`;
